import React,{useState} from 'react';
import stylesLabelUpload from './LabelUpload.module.scss';
import * as actionTypes from '../../redux/actions/actionTypes';
import { Form, Upload, message, Button, Switch } from 'antd';
import Immagine from '../../components/Immagine/Immagine';
import {useSelector, useDispatch} from 'react-redux';
import cancellaDocumento from '../../redux/actions/mock/cancellaDocumento';


const LabelUpload = (props) => {

    const dispatch = useDispatch();

    let uuid = useSelector(state => state.dataReducer.modello.id);
    const apiPath = useSelector(state => state.dataReducer.dataApiPath);

    const nome_documento = props.file;
    let immagine_documento = nome_documento;
    let fileType = ''

    if(nome_documento === 'cedolino' || nome_documento === 'pensione' || nome_documento === 'modelloUnico' ){  
        immagine_documento = 'modello-unico';
        fileType = 'incomeDocument';
    }else if(nome_documento === 'tesserinoSanitario'){
        immagine_documento = 'tesserino-sanitario';
        fileType = 'healthCard';
    }else if(nome_documento === 'cartaIdentita'){
        immagine_documento = 'carta-identita';
        fileType = 'idCard';
    }

    let DocumentoCaricatoFronte = "";
    let DocumentoNonCaricatoFronte = "";
    let DocumentoCaricatoRetro = "";
    let DocumentoNonCaricatoRetro = "";
    let DocumentoCaricatoUnico = "";
    let DocumentoNonCaricatoUnico = "";

    if(immagine_documento === 'modello-unico'){
        DocumentoCaricatoUnico = `caricamento-documenti/${immagine_documento}/modello-unico-caricata.svg`;
        DocumentoNonCaricatoUnico = `caricamento-documenti/${immagine_documento}/modello-unico-non-caricata.svg`;
    }else{
        DocumentoCaricatoFronte = `caricamento-documenti/${immagine_documento}/${immagine_documento}-fronte-caricata.svg`;
        DocumentoNonCaricatoFronte = `caricamento-documenti/${immagine_documento}/${immagine_documento}-fronte-non-caricata.svg`;
        DocumentoCaricatoRetro = `caricamento-documenti/${immagine_documento}/${immagine_documento}-retro-caricata.svg`;
        DocumentoNonCaricatoRetro = `caricamento-documenti/${immagine_documento}/${immagine_documento}-retro-non-caricata.svg`;
        DocumentoCaricatoUnico = `caricamento-documenti/${immagine_documento}/${immagine_documento}-unico-caricata.svg`;
        DocumentoNonCaricatoUnico = `caricamento-documenti/${immagine_documento}/${immagine_documento}-unico-non-caricata.svg`;
    }

    const [loadedUnico, setLoadedUnico] = useState(false);
    const [loadedFronte, setLoadedFronte] = useState(false);
    const [loadedRetro, setLoadedRetro] = useState(false);

    const [fileUnico, setFileUnico] = useState(false);
    const [fileMulti,setFileMulti] = useState([]);


    function cambioCaricamentoFile(checked) {
        if(checked){
            setFileUnico(true);
        }else{
            setFileUnico(false);
        }
        setLoadedUnico(false);
        setLoadedFronte(false);
        setLoadedRetro(false);
    }


    function beforeUploaded(file) {
        const isJpgOrPngOrPdf = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
        if (!isJpgOrPngOrPdf) {
            message.error('Il file non può essere caricato, non rispetta il formato consentito. Puoi caricare file .pdf, .jpg, .png',15);
        }
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isLt3M) {
            message.error('il file non può essere caricato, non rispetta il peso consentito. Puoi caricare file di diemnsioni inferiori a 3Mb',15);
        }
        return isJpgOrPngOrPdf && isLt3M;
    }



    function cambioStatoFileUnico(info){
        if (info.file.status === 'done') {
            setLoadedUnico(true);
            if (fileType === 'idCard') {
                dispatch({type: actionTypes.UPLOADING_ID_DOC_TRUE});
            } else if (fileType === 'healthCard') {
                dispatch({type: actionTypes.UPLOADING_HEALTH_DOC_TRUE});
            } else if (fileType === 'incomeDocument') {
                dispatch({type: actionTypes.UPLOADING_INCOME_DOC_TRUE});
            }
        }
    }
    function cambioStatoFileFronte(info){
        if (info.file.status === 'done') {
            setLoadedFronte(true);
            if (loadedRetro) {
                if (fileType === 'idCard') {
                    dispatch({type: actionTypes.UPLOADING_ID_DOC_TRUE});
                } else if (fileType === 'healthCard') {
                    dispatch({type: actionTypes.UPLOADING_HEALTH_DOC_TRUE});
                } else if (fileType === 'incomeDocument') {
                    dispatch({type: actionTypes.UPLOADING_INCOME_DOC_TRUE});
                }
            }
        }
    }
    function cambioStatoFileRetro(info){
        if (info.file.status === 'done') {
            setLoadedRetro(true);
            if (loadedFronte) {
                if (fileType === 'idCard') {
                    dispatch({type: actionTypes.UPLOADING_ID_DOC_TRUE});
                } else if (fileType === 'healthCard') {
                    dispatch({type: actionTypes.UPLOADING_HEALTH_DOC_TRUE});
                } else if (fileType === 'incomeDocument') {
                    dispatch({type: actionTypes.UPLOADING_INCOME_DOC_TRUE});
                }
            }
        }
    }

    function cambioStatoFileMulti({fileList}){
        setFileMulti(fileList);
        if (fileList.length && fileList.every(file => file.status === 'done')) {
            dispatch({type: actionTypes.UPLOADING_INCOME_DOC_TRUE});
        }
    }

    function removeFileUnico(file){
        dispatch({type: actionTypes.LOADING_CONFERMA_TRUE});
        setLoadedUnico(false);
        if (fileType === 'idCard') {
            dispatch({type: actionTypes.UPLOADING_ID_DOC_FALSE});
        } else if (fileType === 'healthCard') {
            dispatch({type: actionTypes.UPLOADING_HEALTH_DOC_FALSE});
        } else if (fileType === 'incomeDocument') {
            dispatch({type: actionTypes.UPLOADING_INCOME_DOC_FALSE});
        }
        let fileNameSenzaSpazi = file.name.replace(/\s/g, "");
        dispatch(cancellaDocumento(uuid,fileNameSenzaSpazi,apiPath));
    }
    function removeFileFronte(file){
        dispatch({type: actionTypes.LOADING_CONFERMA_TRUE});
        setLoadedFronte(false);
        if (fileType === 'idCard') {
            dispatch({type: actionTypes.UPLOADING_ID_DOC_FALSE});
        } else if (fileType === 'healthCard') {
            dispatch({type: actionTypes.UPLOADING_HEALTH_DOC_FALSE});
        } else if (fileType === 'incomeDocument') {
            dispatch({type: actionTypes.UPLOADING_INCOME_DOC_FALSE});
        }
        let fileNameSenzaSpazi = file.name.replace(/\s/g, "");
        dispatch(cancellaDocumento(uuid,fileNameSenzaSpazi,apiPath));
    }
    function removeFileRetro(file){
        dispatch({type: actionTypes.LOADING_CONFERMA_TRUE});
        setLoadedRetro(false);  
        if (fileType === 'idCard') {
            dispatch({type: actionTypes.UPLOADING_ID_DOC_FALSE});
        } else if (fileType === 'healthCard') {
            dispatch({type: actionTypes.UPLOADING_HEALTH_DOC_FALSE});
        } else if (fileType === 'incomeDocument') {
            dispatch({type: actionTypes.UPLOADING_INCOME_DOC_FALSE});
        }
        let fileNameSenzaSpazi = file.name.replace(/\s/g, "");
        dispatch(cancellaDocumento(uuid,fileNameSenzaSpazi,apiPath));
    }
    function removeFileMulti(file){
        dispatch({type: actionTypes.LOADING_CONFERMA_TRUE});
        let fileNameSenzaSpazi = file.name.replace(/\s/g, "");
        dispatch(cancellaDocumento(uuid,fileNameSenzaSpazi,apiPath));
        let newFileMulti = [...fileMulti];
        newFileMulti = newFileMulti.filter(f => f.uid !== file.uid);
        setFileMulti(newFileMulti);
        if (newFileMulti.length === 0) {
            dispatch({type: actionTypes.UPLOADING_INCOME_DOC_FALSE});
        }
    }
    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };

    return (
        <div className={stylesLabelUpload.LabelUpload}>
            <h2 className={stylesLabelUpload.Label}>
                {
                nome_documento === 'cartaIdentita' ? `Carta d'identità` 
                : nome_documento === 'tesserinoSanitario' ? `Tessera sanitaria`
                : nome_documento === 'modelloUnico' ? `Documento di reddito`
                : nome_documento === 'cedolino' ? `Documento di reddito`
                : nome_documento === 'pensione' ? `Documento di reddito` : null
                }
                </h2>
                {
                    nome_documento === 'modelloUnico' ||  nome_documento === 'cedolino' ||  nome_documento === 'pensione' ? (
                        <p className={stylesLabelUpload.textLabelUpload}>
                            {
                                nome_documento === 'modelloUnico' ? 'Puoi usare il tuo ultimo Modello Unico' 
                                : nome_documento === 'cedolino' ? 'Puoi usare la tua ultima Busta Paga' 
                                : nome_documento === 'pensione' ? 'Puoi usare il tuo ultimo Cedolino della Pensione, il Modello OBIS/M o il C.U.' 
                                : null
                            }
                        </p>
                    ) : null
                }

            <div className={stylesLabelUpload.Switch}>
                <Switch onChange={cambioCaricamentoFile} /> Carica File Unico
            </div>

            <div className={stylesLabelUpload.Clear}></div>

            {
                fileUnico ? (
                    <>
                        <div className={stylesLabelUpload.Upload}>
                        <Form.Item
                            name={`${nome_documento}Unico`}
                            className={stylesLabelUpload.itemUpload}
                            valuePropName="fileList"
                            getValueFromEvent={normFile}
                            rules={[
                                {
                                required: true,
                                message: 'Carica file unico',
                                },
                            ]}
                            >
                            <Upload
                                name="file"
                                action={`uploadDocumento?id=${uuid}&fileType=${fileType}`}
                                beforeUpload={beforeUploaded} // puoi usare () => false per evitare l'upload automatico
                                onChange={cambioStatoFileUnico}
                                onRemove={removeFileUnico}
                                listType="text"
                            >
                                {loadedUnico ? (
                                <Immagine urlImage={DocumentoCaricatoUnico} name={nome_documento} />
                                ) : (
                                <Immagine urlImage={DocumentoNonCaricatoUnico} name={nome_documento} />
                                )}
                                <Button />
                                <h4 className={stylesLabelUpload.textUpload}>File unico</h4>
                            </Upload>
                        </Form.Item>

                        </div>
                    </>
                ) : (immagine_documento !== 'modello-unico') ? (
                    <>
                        <div className={stylesLabelUpload.Upload}>
                            <Form.Item
                                name={`${nome_documento}Fronte`}
                                className={stylesLabelUpload.itemUpload}
                                valuePropName="fileList"
                                getValueFromEvent={normFile}
                                rules={[
                                    {
                                    required: true,
                                    message: 'Carica file fronte',
                                    },
                                ]}
                                >
                                <Upload
                                    name="file"
                                    action={`uploadDocumento?id=${uuid}&fileType=${fileType}`}
                                    beforeUpload={beforeUploaded} // oppure () => false se vuoi disattivare l'upload automatico
                                    onChange={cambioStatoFileFronte}
                                    onRemove={removeFileFronte}
                                    listType="text"
                                >
                                    {loadedFronte ? (
                                    <Immagine urlImage={DocumentoCaricatoFronte} name={nome_documento} />
                                    ) : (
                                    <Immagine urlImage={DocumentoNonCaricatoFronte} name={nome_documento} />
                                    )}
                                    <Button />
                                    <h4 className={stylesLabelUpload.textUpload}>Fronte</h4>
                                </Upload>
                            </Form.Item>

                        </div>

                        <div className={stylesLabelUpload.Upload}>
                        <Form.Item
                            name={`${nome_documento}Retro`}
                            className={stylesLabelUpload.itemUpload}
                            valuePropName="fileList"
                            getValueFromEvent={normFile}
                            rules={[
                                {
                                required: true,
                                message: 'Carica file retro',
                                },
                            ]}
                            >
                            <Upload
                                name="file"
                                action={`uploadDocumento?id=${uuid}&fileType=${fileType}`}
                                beforeUpload={beforeUploaded} // oppure () => false se vuoi bloccare upload automatico
                                onChange={cambioStatoFileRetro}
                                onRemove={removeFileRetro}
                                listType="text"
                            >
                                {loadedRetro ? (
                                <Immagine urlImage={DocumentoCaricatoRetro} name={nome_documento} />
                                ) : (
                                <Immagine urlImage={DocumentoNonCaricatoRetro} name={nome_documento} />
                                )}
                                <Button />
                                <h4 className={stylesLabelUpload.textUpload}>Retro</h4>
                            </Upload>
                        </Form.Item>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={stylesLabelUpload.Upload}>
                            <Form.Item
                                name={`${nome_documento}Multi`}
                                className={stylesLabelUpload.itemUpload}
                                valuePropName="fileList"
                                getValueFromEvent={normFile}
                                rules={[
                                    {
                                    required: true,
                                    message: 'Carica file multi',
                                    },
                                ]}
                                >
                                <Upload
                                    name="file"
                                    action={`uploadDocumento?id=${uuid}&fileType=${fileType}`}
                                    beforeUpload={beforeUploaded}
                                    onChange={cambioStatoFileMulti}
                                    onRemove={removeFileMulti}
                                    fileList={fileMulti}        // controllato esternamente
                                    multiple                   // abilitazione caricamento multiplo
                                    listType="text"
                                >
                                    {/* Immagini dei file già caricati */}
                                    {fileMulti.map((singolo) => (
                                    <Immagine
                                        key={singolo.uid}
                                        urlImage={DocumentoCaricatoUnico}
                                        name={nome_documento}
                                        chiave={singolo.uid}
                                    />
                                    ))}

                                    {/* Pulsante per aggiungere nuovi file (max 30) */}
                                    {fileMulti.length < 30 && (
                                    <>
                                        <Immagine
                                        urlImage={DocumentoNonCaricatoUnico}
                                        class={stylesLabelUpload.FileMulti}
                                        name={nome_documento}
                                        />
                                        <Button />
                                    </>
                                    )}

                                    <h4 className={stylesLabelUpload.textUpload}>
                                    Carica massimo 30 pagine
                                    </h4>
                                </Upload>
                            </Form.Item>

                        </div>
                    </>
                )
            }


        </div>
    )
}

export default LabelUpload;